var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#A020FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3667 18.0833C28.3667 23.7627 23.7627 28.3667 18.0833 28.3667C12.404 28.3667 7.8 23.7627 7.8 18.0833C7.8 12.404 12.404 7.8 18.0833 7.8C23.7627 7.8 28.3667 12.404 28.3667 18.0833Z",
    stroke: "white",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9209 31.2C29.8455 31.2 29.7761 31.1691 29.7341 31.1271L26.877 28.2677C26.7813 28.172 26.7658 27.998 26.8819 27.872C26.9786 27.7805 27.149 27.7677 27.2725 27.8834L30.123 30.7361C30.2161 30.8292 30.2332 30.9964 30.1274 31.1214C30.0609 31.1761 29.9854 31.2 29.9209 31.2Z",
    stroke: "white",
    strokeWidth: 1.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleSearchIcon);
export default __webpack_public_path__ + "static/media/PurpleSearchIcon.12fee79cec9cecd4b9debc53bebd4b45.svg";
export { ForwardRef as ReactComponent };